<template>
    <div class="container-fluid h-100">
        <div class="container">
            <div class="row mt-5 pt-3">
                <div class="col-12" style="text-align: initial">
                    <h4 class="text-danger mt-3 mb-3">
                        <strong>Reporte de actualizaciones </strong>
                        <button style="float: right;" data-bs-toggle="tooltip" data-bs-placement="bottom"
                            title="Actualizar lubricadores" class="btn btn-success" @click="irR()">
                            <i class="fa fa-users m-0 p-0" aria-hidden="true"></i>
                        </button>
                    </h4>
                    <template v-if="loading.history">
                        <div class="row justify-content-center">
                            <div>
                                <div class="spinner-border text-danger"
                                    style="width: 4em; height: 4rem; text-align: center" role="status"></div>

                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div id="accordion" class="pt-4">
                            <div v-for="(item, i) in items" class="card">
                                <div data-toggle="collapse" @click="details(item.id)"
                                    :data-target="'#idCollapse' + item.id" aria-expanded="false"
                                    :aria-controls="'idCollapse'+item.id" class="card-header" id="headingOne">
                                    <div class="row" style="cursor: pointer">
                                        <div class="col-4">
                                            <h6 class="text-info mb-0">{{ item.origin }}</h6>
                                        </div>
                                        <div class="col-4">
                                            <h6 class="text-info mb-0">{{ item.created_at }}</h6>
                                        </div>
                                        <div class="col-4">
                                            <h6 class="text-info mb-0" v-if="item.user!=NULL">
                                                Responsable: {{ item.user.name }}
                                                {{ item.user.last_name }}
                                            </h6>
                                        </div>
                                    </div>
                                </div>

                                <div :id="'idCollapse' + item.id" class="collapse" aria-labelledby="headingOne"
                                    data-parent="#accordion">
                                    <div class="card-body">

                                        <template v-if="loading.history2">
                                            <div class="row justify-content-center">
                                                <div>
                                                    <div class="spinner-border text-danger"
                                                        style="width: 4em; height: 4rem; text-align: center"
                                                        role="status"></div>

                                                </div>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <table class="table">
                                                <caption class="visually-hidden">Listado de Reportes</caption>
                                                <thead>
                                                    <tr>
                                                        <th scope="col">Fecha</th>
                                                        <th scope="col">Mensaje</th>
                                                        <th scope="col">Usuario</th>
                                                        <th scope="col">Estado</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="details in itemsD">
                                                        <td style="text-align: left">{{details.created_at}}</td>
                                                        <td style="text-align: left">{{details.message}}</td>
                                                        <td style="text-align: left">
                                                            <template v-if="details.user != null">
                                                                {{details.user.document_number}}
                                                            </template>
                                                            <template v-else>
                                                                <small> No aplica </small>
                                                            </template>
                                                        <td style="text-align: left">
                                                            <span v-if="details.status.id == 6"
                                                                class="badge badge-pill badge-success">
                                                                {{ details.status.name }}
                                                            </span>
                                                            <span v-if="details.status.id == 7"
                                                                class="badge badge-pill badge-danger">
                                                                {{ details.status.name }}
                                                            </span>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </template>


                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import vPagination from "vue-plain-pagination";
    export default {
        components: {vPagination},
        data() {
            return {
                errorsFile: false,
                errorsFile2: false,
                totalPages: 4,
                bootstrapPaginationClasses: {
                    ul: "pagination",
                    li: "page-item",
                    liActive: "active",
                    liDisable: "disabled",
                    button: "page-link"
                },
                totaItems: null,
                currentPage: 1,
                listD: [],
                distri: null,
                items: [],
                itemsD: [],
                searchN: "",
                form: {
                    event_points: "",
                    id: 0,
                    name: "",
                    points: "",
                    email: ""
                },
                formA: {
                    field: null,
                    action: null,
                    file: null
                },
                errors: {
                    id: 0,
                    name: false,
                    email: false,
                    points: false,
                    event_points: false
                },
                loading: {
                    history: false,
                    changeDoc: false,
                    modal: false,
                    history2: false
                },
                paginate: ["items"],
                page: 1,
                isWon: false,
                validateAction: false // valida que debe cpnsumir al momento de cambiar página en el watch
            };
        },
        methods: {
            details(data) {
                console.log(data);
                this.itemsD = [];
                this.loading.history2 = true;
                axios
                    .get("superAdmin/log/report/" + data)
                    .then(res => {
                        if (res.data.cod == 0) {
                            this.itemsD = res.data.data;
                        }
                        this.loading.history2 = false;
                    })
                    .catch(error => {
                        this.loading.history2 = false;
                    });
            },
            irR() {
                this.$router.push({name: "adminL"});
            },
            getData() {
                this.items = [];
                this.loading.history = true;
                axios
                    .get("superAdmin/log/report")
                    .then(res => {
                        if (res.data.cod == 0) {
                            this.items = res.data.data;

                            console.log("PASO")
                        }
                        this.loading.history = false;
                    })
                    .catch(error => {
                        this.loading.history = false;
                    });
            }
        },
        mounted() {
            this.getData();
        },
        watch: {
            currentPage: function (newL) {
                if (this.validateAction) {
                    this.search();
                } else {
                    this.getData();
                }
            },
            searchN: function (newN) {},
            "form.name": function (newV) {
                if (!newV) {
                    this.errors.name = "El nombre del producto es requerido.";
                } else {
                    this.errors.name = false;
                }
            },
            "form.description": function (newV) {
                if (!newV) {
                    this.errors.description = "La descripción del producto es requerida.";
                } else {
                    this.errors.description = false;
                }
            },
            "form.state_id": function(n) {
                if (n) {
                    this.getCities(n);
                }       
            },
            "form.status": function (newV) {
                if (!newV) {
                    this.errors.status = "El estado del producto es requerido.";
                } else {
                    this.errors.status = false;
                }
            }
        }
    };
</script>

<style>
.container-fluid,
.container-lg,
.container-md,
.container-sm,
.container-xl {
    padding-right: 0px !important;
    padding-left: 0px !important;
    overflow: hidden;
}
.div-button {
    margin-top: 50px;
    text-align: left;
}
.is-danger {
    border: solid 2px !important;
    border-color: #e9434c !important;
}
.modal-title {
    color: black;
    font-weight: bold;
}
.modal-question {
    border: solid 3px;
    border-color: #dc3545;
    border-radius: 15px;
}
label {
    color: black;
    margin-right: 4px;
}
.img-banner {
    display: block;
    width: 25%;
    text-align: center;
    margin: auto;
}
td {
    text-align: center;
    vertical-align: -webkit-baseline-middle;
    cursor: all-scroll;
}
.table-container {
    overflow: auto;
}
h5 {
    margin-bottom: 10px !important;
}
.commentary {
    text-align: left;
    color: #1da5df;
    font-size: 13px;
}
.page-item.active .page-link {
    z-index: 3;
    color: #fff;
    background-color: #dc3545;
    border-color: #dc3545;
}
.page-link {
    border-radius: 100px;
    position: relative;
    display: block;
    padding: 0.5rem 0.75rem;
    margin-left: -1px;
    line-height: 1.25;
    color: #dc3545;
    background-color: #fff;
    border: 1px solid #dee2e6;
}
.page-link:hover {
    color: #000;
}
.visually-hidden {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
}
</style>
